import request from "@/utils/request";
import { envInfo } from "@/constants/envInfo";

/**
 * 门禁列表
 */
export function getDoorList(params) {
  return request({
    url: envInfo.bgApp.attendancePath + "/door/list",
    method: "post",
    data: params
  });
}

/**
 * 绑点接口
 */
export function bindPosition(params) {
  return request({
    url: envInfo.bgApp.attendancePath + "/door/bindPosition",
    method: "post",
    data: params
  });
}

/**
 * 远程开门
 */
export function remoteOpenDoor(params) {
  return request({
    url: envInfo.bgApp.attendancePath + "/door/remoteOpenDoor",
    method: "get",
    params
  });
}

/**
 * 删除设备
 */
 export function unBindPosition(params) {
  return request({
    url: envInfo.bgApp.attendancePath + "/door/unBindPosition",
    method: "post",
    data: params
  });
}

/**
 * 人脸记录
 */
 export function recognitionRecord(params) {
  return request({
    url: envInfo.bgApp.attendancePath + "/door/getOneFaceRecordList",
    method: "get",
    params
  });
}

/**
 * 二期人脸记录
 */
 export function staffPictureList(params) {
  return request({
    url: envInfo.bgApp.attendancePath + "/door/getTwoFaceRecordList",
    method: "get",
    params
  });
}

/**
 * 停车场
 */
 export function parkingAreaRecord(params) {
  return request({
    url: envInfo.bgApp.defaultPath + "/tenant/devicemap/parkingAreaRecord",
    method: "get",
    params
  });
}

export function getHomeDetail(){
  return request({
    url: envInfo.bgApp.attendancePath + "/door/getHomeDetail",
    method: "get"
  })
}

/**
 * 人脸记录
 */
 export function getChart() {
  return request({
    url: envInfo.bgApp.attendancePath + "/door/getChart",
    method: "get"
  });
}

/**
 * 人脸记录
 */
 export function getOneTrendChart(params) {
  return request({
    url: envInfo.bgApp.attendancePath + "/door/getOneTrendChart",
    method: "get",
    params
  });
}

/**
 * 二期人脸记录
 */
 export function getTwoTrendChart(params) {
  return request({
    url: envInfo.bgApp.attendancePath + "/door/getTwoTrendChart",
    method: "get",
    params
  });
}

/**
 * 一期门禁记录
 */
 export function getDoorRecordList(params) {
  return request({
    url: envInfo.bgApp.attendancePath + "/door/getDoorRecordList",
    method: "get",
    params
  });
}

/**
 * 一期门禁记录-趋势图
 */
 export function getDoorTrendChart(params) {
  return request({
    url: envInfo.bgApp.attendancePath + "/door/getDoorTrendChart",
    method: "get",
    params
  });
}

/**
 * 一期停车场记录
 */
 export function parkingAreaRecordFirst(params) {
  return request({
    url: envInfo.bgApp.defaultPath + "/tenant/devicemap/parkingAreaRecordFirst",
    method: "get",
    params
  });
}

/**
 * 一期停车场记录新接口
 */
 export function parkingAreaRecordFirstNew(params) {
  return request({
    url: envInfo.bgApp.defaultPath + "/tenant/devicemap/parkingAreaRecordFirstNew",
    method: "get",
    params
  });
}